import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { SharedServiceService } from 'app/services/shared-service.service';

@Component({
  selector: 'app-disable-service',
  templateUrl: './disable-service.component.html',
  styleUrls: ['./disable-service.component.scss']
})
export class DisableServiceComponent implements OnChanges {

  @Input() showBox = false;
  @Input() message = "این سرویس به زودی اضافه می شود.";
  @Output() closeBox: EventEmitter<any> = new EventEmitter();
  constructor(private sharedService: SharedServiceService) { }
  ngOnChanges(): void {
    if (this.showBox) {
      this.checkPopUpBottom();
    }
  }
  checkPopUpBottom() {
    setTimeout(() => this.sharedService.handlePopupBottom(), 2);
  }
  close() {
    this.showBox = false;
    this.checkPopUpBottom();
    this.closeBox.emit();
  }
}
